<lib-cart></lib-cart>
<div class="row">
  <div *ngIf="!isReturNoPrice" class="col-2 offset-10">
    <lib-cart-summary></lib-cart-summary>
  </div>
</div>
<div *ngIf="freightFree.display && !currentFlow?.isReturnOrder" style="padding: 10px 0 10px 0; float: rigth">
  <div style="text-align: end">
    <span translate> ORDER_AMOUNT_BELOW_FRIEGHT_FREE_LIMIT </span>
    <strong>{{
      freightFree.diffToTotal.value | gungCurrency: freightFree.diffToTotal.currencyCode:'symbol-narrow':'1.2-2'
    }}</strong>
    <span translate>ORDER_AMOUNT_BELOW_FREIGHT_FREE_LIMIT_2</span>
  </div>
</div>
<div *ngIf="currentFlow?.isReturnOrder && !isReturNoPrice" style="padding: 10px 0 10px 0; float: rigth">
  <div style="text-align: end">
    <span translate>AMOUNT_RECIVED_WHEN_APPROVED</span>
  </div>
</div>
